import React, { useEffect, useState } from 'react';
import { Link } from 'react-router-dom';
import { FaWhatsapp } from 'react-icons/fa';
import data from '../data/excipients.json';
import Excipient from "../Images/Excipient.jpg";
import logo from "../Images/aman logo.png";

const ITEMS_PER_PAGE = 40;

const Excipients = () => {
    const [products, setProducts] = useState([]);
    const [page, setPage] = useState(1);

    useEffect(() => {
        setProducts(data);
    }, []);

    const totalPages = Math.ceil(products.length / ITEMS_PER_PAGE);
    const startIndex = (page - 1) * ITEMS_PER_PAGE;
    const pagedData = products.slice(startIndex, startIndex + ITEMS_PER_PAGE);

    const handlePageChange = (newPage) => {
        if (newPage >= 1 && newPage <= totalPages) {
            setPage(newPage);
        }
    };

    return (
        <>
            {/* ✅ Sliding Banner */}
            <div className="InterMedite Product-image">
                <div className="InterMedite Product-slide-track">
                    {[...Array(12)].map((_, i) => (
                        <img key={i} src={Excipient} alt="Excipient Slide" className="slide" />
                    ))}
                </div>
            </div>

            {/* ✅ Product List */}
            <div className="search-page">
                <h2>
                    <span className="Searchcount">Excipients Products List</span>
                    <span className="count">({products.length})</span>
                </h2>

                <div className="products-container">
                    <div className="results-scrollable">
                        <div className="results-grid">
                            {pagedData.map((item, index) => {
                                const productSlug = `${encodeURIComponent(item.productName)}-${encodeURIComponent(item.casNumber)}`;
                                const productLink = `${window.location.origin}/#/product/${productSlug}`;

                                return (
                                    <div key={index} className="result-card">
                                        <div className="card-header">
                                            <img src={logo} alt="Product Logo" className="card-logo" />
                                            <button
                                                className="whatsapp-button"
                                                onClick={() => {
                                                    const message = `Hello! I'm interested in this product:\n\n*Name:* ${item.productName}\n*CAS Number:* ${item.casNumber}\n\n*View Product:*\n${productLink}`;
                                                    const phoneNumber = '7405649537';
                                                    const url = `https://wa.me/${phoneNumber}?text=${encodeURIComponent(message)}`;
                                                    window.open(url, '_blank');
                                                }}
                                            >
                                                <FaWhatsapp size={18} />
                                            </button>
                                        </div>

                                        <div className="field">
                                            <span className="label">Product Name:</span>
                                            <Link
                                                to={`/product/${productSlug}`}
                                                state={{ backTo: window.location.pathname }}
                                                className="value link"
                                            >
                                                {item.productName}
                                            </Link>
                                        </div>

                                        <div className="field">
                                            <span className="label">CAS Number:</span>
                                            <span className="value">{item.casNumber}</span>
                                        </div>
                                    </div>
                                );
                            })}
                        </div>
                    </div>
                </div>

                {/* ✅ Pagination */}
                <div className="pagination">
                    <button onClick={() => handlePageChange(page - 1)} disabled={page === 1}>‹ Prev</button>

                    {(() => {
                        const maxVisibleButtons = 7;
                        let startPage = Math.max(1, page - Math.floor(maxVisibleButtons / 2));
                        let endPage = startPage + maxVisibleButtons - 1;

                        if (endPage > totalPages) {
                            endPage = totalPages;
                            startPage = Math.max(1, endPage - maxVisibleButtons + 1);
                        }

                        const pagesToShow = [];
                        for (let p = startPage; p <= endPage; p++) {
                            pagesToShow.push(p);
                        }

                        return (
                            <>
                                {startPage > 1 && (
                                    <>
                                        <button onClick={() => handlePageChange(1)}>1</button>
                                        {startPage > 2 && <span className="dots">...</span>}
                                    </>
                                )}

                                {pagesToShow.map(p => (
                                    <button
                                        key={p}
                                        onClick={() => handlePageChange(p)}
                                        className={`page-number ${p === page ? 'active' : ''}`}
                                    >
                                        {p}
                                    </button>
                                ))}

                                {endPage < totalPages && (
                                    <>
                                        {endPage < totalPages - 1 && <span className="dots">...</span>}
                                        <button onClick={() => handlePageChange(totalPages)}>{totalPages}</button>
                                    </>
                                )}
                            </>
                        );
                    })()}

                    <button onClick={() => handlePageChange(page + 1)} disabled={page === totalPages}>Next ›</button>
                </div>
            </div>
        </>
    );
};

export default Excipients;
